export const Acronyms = {
	GSD: {
		expanded: "Get Sh!t Done",
		acronym: "GSD"
	},
		IRL: {
		expanded: "in real life",
		acronym: "IRL"
	},
		SFFD: {
		expanded: "San Francisco Fire Department",
		acronym: "SFFD"
	},
		SFPD: {
		expanded: "San Francisco Police Department",
		acronym: "SFPD"
	},
}

export const Citations = {
	"1": {
		link:"https://sfethics.org/ethics/2018/03/campaign-finance-dashboards-june-5-2018-and-november-6-2018-elections.html",
		publication:"SF Ethics Commission",
		headline: "SF Mayor's race",
		directQuote:"This is just counting contributions, which does not include funding from PACs, or public financing. Michelle has received no other financing from these two sources."
	},
		"2": {
		link:'https://www.facebook.com/bradchapin007/videos/10213824532920362/?q=michelle%20bravo&filters_rp_location=%7B%22name%22%3A%22location%22%2C%22args%22%3A%22114952118516947%22%7D',
		publication:"Brad Joseph Chapin's Facebook live video",
		headline: "Michelle Bravo (03:25)",
		directQuote: "Again, I'm taking my time with this experience because that's what this is for me. It's an experience."
	},
		"3": {
		link:'https://www.linkedin.com/in/bravom1/',
		publication:"LinkedIn",
		headline: "Michelle Bravo's profile",
		directQuote: "As a holistic health practitioner, I provide clients with a multifaceted approach to health and wellness."
	},
}


// WEBPACK FOOTER //
// ./src/pages/june-5/races/data/SFMayor/mb/expandables.js